module.exports = __webpack_public_path__ + "static/media/authentication-and-authorization.3a2a1067.jpg";